import { useRouter } from "next/router"
import { useEffect, useRef } from "react"

export const usePreserveScroll = (enable?: boolean) => {
  const router = useRouter();

  const scrollPositions = useRef<{ [url: string]: number }>({});
  const isBack = useRef(false);

  useEffect(() => {
    window.history.scrollRestoration = 'manual';
    router.beforePopState((state) => {
      isBack.current = true;

      return true;
    })

    const onRouteChangeStart = () => {
      const url = router.asPath;
      scrollPositions.current[url] = window.scrollY;
    }

    const onRouteChangeComplete = (url: string, ...args) => {
			if (!enable) {
				window.scroll({
          top: 0,
          behavior: "auto",
        });
			}

			if (enable && isBack.current && scrollPositions.current[url]) {
        window.scroll({
          top: scrollPositions.current[url],
          behavior: "auto",
        });
      }

      isBack.current = false;
    }

    router.events.on("routeChangeStart", onRouteChangeStart);
    router.events.on("routeChangeComplete", onRouteChangeComplete);

    return () => {
      router.events.off("routeChangeStart", onRouteChangeStart);
      router.events.off("routeChangeComplete", onRouteChangeComplete);
    }
  }, [enable, router]);
};
